<template>
  <div
    class="c-population-tab-list-subheader bg-neutral-background-weak px-4 py-8"
  >
    <div
      class="grid grid-cols-[2.5fr_1.5fr_1.5fr_1.5fr_110px] gap-4 items-center"
    >
      <div class="flex items-center gap-8 px-8 col-span-5">
        <BittsCheckbox
          v-if="canEdit"
          class="mr-8"
          :checked="allItemsSelected"
          :indeterminate="someItemsSelected"
          @input="emit('select-all', $event)"
        />
        <span class="text-sm font-bold text-neutral-text whitespace-nowrap">
          {{ title }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsCheckbox } from '@crossbeam/bitts';

type Props = {
  title: string;
  allItemsSelected: boolean;
  someItemsSelected: boolean;
  canEdit?: boolean;
};

withDefaults(defineProps<Props>(), {
  canEdit: true,
});

const emit = defineEmits<{
  'select-all': [checked: boolean];
}>();
</script>
